import React from "react";
import { FiltersTypes } from "../../../../../common/types/filters/general";

interface Props {
    filters: FiltersTypes;
}

export const DueDateFilterLabel: React.FC<Props> = ({ filters }) => {
    const { overdue, minOverdue, maxOverdue } = filters;

    if (overdue === undefined) {
        return null;
    }

    // Format the range label based on min and max values
    const getRangeLabel = () => {
        if (minOverdue === undefined && maxOverdue === undefined) {
            return "";
        }

        if (minOverdue !== undefined && maxOverdue !== undefined) {
            return `${minOverdue}-${maxOverdue}d`;
        }

        if (minOverdue !== undefined) {
            return `${minOverdue}d+`;
        }

        if (maxOverdue !== undefined) {
            return `0-${maxOverdue}d`;
        }

        return "";
    };

    const rangeLabel = getRangeLabel();
    const statusLabel = overdue ? "Overdue" : "Not yet due";

    return (
        <span>
            {rangeLabel && <span>{rangeLabel} </span>}
            {statusLabel}
        </span>
    );
};
